module.exports = __webpack_public_path__ + "static/media/ic_uparrow.f54f339d.svg";